import { DomaQueryService } from "../../../services/payments/DomaQueryService";
import { DomaModel } from "../../models/Doma";
import { IQueryDomaRepository } from "../../ports/payments/IQueryDomaRepository";
import Query from "../Query";

class DomaQuery extends Query<DomaModel> implements IQueryDomaRepository {
  constructor(public queryService: DomaQueryService) {
    super(queryService);
  }
}

export default DomaQuery;
